export default "__VITE_ASSET__DlAJ_xZl__"